import { CacheKey } from '~/enums/cache'

// these APIs are auto-imported from @vueuse/core
export const isDark = useDark({ initialValue: 'light', valueLight: 'light', emitAuto: false, listenToStorageChanges: false, storageKey: CacheKey.COLOR_SCHEME })
export const toggleDark = useToggle(isDark)
export const preferredDark = usePreferredDark()
